import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

const BatonRouge = () => {
  const nearbyFacilities = [
    { name: 'ExxonMobil Baton Rouge', type: 'Refinery', capacity: '502,500 BPD' },
    { name: 'Marathon Garyville', type: 'Refinery', capacity: '578,000 BPD' },
    { name: 'Shell Norco', type: 'Refinery', capacity: '240,000 BPD' },
    { name: 'CF Industries Donaldsonville', type: 'Fertilizer Plant', capacity: '3.8M tons/year' },
    { name: 'Dow St. Charles', type: 'Chemical Complex', capacity: 'Major Facility' },
    { name: 'Formosa Plastics', type: 'Petrochemical', capacity: 'Major Complex' }
  ];

  const faqData = [
    {
      question: "Do you buy valves from Baton Rouge refineries?",
      answer: "Yes, we purchase surplus valves, Fisher control valves, and instrumentation from Baton Rouge refineries including ExxonMobil, Shell Norco, and Marathon Garyville. We provide 4-6 hour response times with competitive pricing for River Parish facilities."
    },
    {
      question: "What types of equipment do you buy in Baton Rouge?",
      answer: "We buy control valves, ball valves, gate valves, globe valves, heat exchangers, pumps, compressors, safety systems, Rosemount transmitters, flow meters, analyzers, and controllers from Baton Rouge refineries and chemical plants."
    },
    {
      question: "How quickly can you respond to Baton Rouge facilities?",
      answer: "We provide 4-6 hour response times for Baton Rouge and surrounding River Parish facilities. Our team has 20+ years of experience serving Louisiana's major refining and petrochemical corridor."
    },
    {
      question: "Do you purchase equipment from River Parish chemical plants?",
      answer: "Yes, we buy process equipment and instrumentation from River Parish chemical facilities including Dow St. Charles, CF Industries Donaldsonville, and Formosa Plastics. We provide professional valuations for petrochemical equipment."
    },
    {
      question: "What valve brands do you buy from Baton Rouge facilities?",
      answer: "We purchase Fisher, Masoneilan, Flowserve, Cameron, Rosemount, Emerson, Honeywell, and other major brands from Baton Rouge refineries, chemical plants, and petrochemical facilities."
    },
    {
      question: "Do you serve other Louisiana cities from Baton Rouge?",
      answer: "Yes, our Baton Rouge service area covers all of Louisiana including Lake Charles, Beaumont area facilities, and the entire Gulf Coast refining corridor. We provide fast response times throughout the region."
    }
  ];

  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": "https://valvesalessupply.com/baton-rouge",
        "url": "https://valvesalessupply.com/baton-rouge",
        "name": "We Buy Valves Baton Rouge | Industrial Equipment Buyers Baton Rouge Louisiana",
        "description": "We buy valves Baton Rouge Louisiana - Professional valve buyers serving Louisiana River Parish refineries. We purchase surplus valves, control systems, and instrumentation at above scrap rates. Call 214-854-5638.",
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://valvesalessupply.com"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Louisiana",
              "item": "https://valvesalessupply.com/louisiana"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": "Baton Rouge",
              "item": "https://valvesalessupply.com/baton-rouge"
            }
          ]
        }
      },
      {
        "@type": "LocalBusiness",
        "name": "Valve Sales Supply - Baton Rouge",
        "image": "https://valvesalessupply.com/logo.png",
        "@id": "https://valvesalessupply.com/baton-rouge",
        "url": "https://valvesalessupply.com/baton-rouge",
        "telephone": "214-854-5638",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Baton Rouge",
          "addressRegion": "LA",
          "addressCountry": "US"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": 30.4515,
          "longitude": -91.1871
        },
        "areaServed": {
          "@type": "City",
          "name": "Baton Rouge",
          "containedIn": {
            "@type": "State",
            "name": "Louisiana"
          }
        },
        "serviceType": ["Industrial Valve Buyers", "Refinery Equipment Buyers", "Chemical Plant Equipment", "Petrochemical Equipment"]
      },
      {
        "@type": "FAQPage",
        "mainEntity": faqData.map(faq => ({
          "@type": "Question",
          "name": faq.question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": faq.answer
          }
        }))
      }
    ]
  };

  useEffect(() => {
    // Set page title
    document.title = "We Buy Valves Baton Rouge | Industrial Equipment Buyers Baton Rouge Louisiana";
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'We buy valves Baton Rouge Louisiana - Professional valve buyers serving Louisiana River Parish refineries. We purchase surplus valves, control systems, and instrumentation at above scrap rates. Call 214-854-5638.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'We buy valves Baton Rouge Louisiana - Professional valve buyers serving Louisiana River Parish refineries. We purchase surplus valves, control systems, and instrumentation at above scrap rates. Call 214-854-5638.';
      document.head.appendChild(meta);
    }
    
    // Update meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', 'we buy valves baton rouge, baton rouge valve buyers, louisiana refineries, river parish equipment, surplus valves');

    // Add canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://valvesalessupply.com/baton-rouge');

    // Add Open Graph tags
    const ogTags = [
      { property: 'og:title', content: 'We Buy Valves Baton Rouge | Industrial Equipment Buyers Baton Rouge Louisiana' },
      { property: 'og:description', content: 'We buy valves Baton Rouge Louisiana - Professional valve buyers serving Louisiana River Parish refineries.' },
      { property: 'og:url', content: 'https://valvesalessupply.com/baton-rouge' },
      { property: 'og:type', content: 'website' }
    ];

    ogTags.forEach(tag => {
      let meta = document.querySelector(`meta[property="${tag.property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', tag.property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', tag.content);
    });

    // Add geo tags
    const geoTags = [
      { name: 'geo.position', content: '30.4515;-91.1871' },
      { name: 'geo.placename', content: 'Baton Rouge, Louisiana' },
      { name: 'geo.region', content: 'US-LA' }
    ];

    geoTags.forEach(tag => {
      let meta = document.querySelector(`meta[name="${tag.name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', tag.name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', tag.content);
    });

    // Add Schema.org structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript && existingScript.textContent === JSON.stringify(schemaData)) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen">
      
      <Header />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-900 to-slate-800 text-white py-20">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              <span className="text-blue-300">**Baton Rouge**</span> Industrial Equipment Buyers
            </h1>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto">
              Serving Louisiana's **River Parish refineries** and chemical facilities with professional equipment evaluations. 
              We purchase **surplus valves**, control systems, and instrumentation at competitive rates.
            </p>
            <div className="mt-8">
              <a href="tel:214-854-5638" className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-200">
                Call Now: **214-854-5638**
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Service Area Stats */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-3xl font-bold text-blue-600 mb-2">6</h3>
              <p className="text-gray-600">Major Refineries & Chemical Plants</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-3xl font-bold text-green-600 mb-2">4-6 Hours</h3>
              <p className="text-gray-600">Response Time</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-3xl font-bold text-orange-600 mb-2">20+ Years</h3>
              <p className="text-gray-600">Industry Experience</p>
            </div>
          </div>
        </div>
      </section>

      {/* Major Facilities */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
            **Major Industrial Facilities** We Serve
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {nearbyFacilities.map((facility, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-lg border-l-4 border-blue-500">
                <h3 className="font-bold text-lg mb-2 text-gray-800">**{facility.name}**</h3>
                <p className="text-blue-600 font-semibold mb-1">{facility.type}</p>
                <p className="text-gray-600">{facility.capacity}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Equipment We Buy */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
            Equipment We Purchase in **Baton Rouge**
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-lg">
              <h3 className="text-2xl font-bold mb-6 text-blue-600">**Control & Safety Systems**</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  **Fisher Control Valves** (All Series)
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  **Masoneilan** Control Systems
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  **Safety Relief Valves** & Systems
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  **Emergency Shutdown** Systems
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  **Process Controllers** & Actuators
                </li>
              </ul>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-lg">
              <h3 className="text-2xl font-bold mb-6 text-orange-600">**Instrumentation & Measurement**</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  **Rosemount Transmitters** (All Models)
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  **Flow Meters** & Measurement Systems
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  **Pressure Gauges** & Transmitters
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  **Analyzers** & Testing Equipment
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  **Temperature Controllers** & Sensors
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Service Areas */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Our Service Coverage in Baton Rouge
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              We provide equipment pickup services throughout the greater Baton Rouge metropolitan area
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">North Baton Rouge</h3>
              <p className="text-gray-600">Zachary, Baker, Pride areas</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">South Baton Rouge</h3>
              <p className="text-gray-600">Geismar, Gonzales, Prairieville areas</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">East Baton Rouge</h3>
              <p className="text-gray-600">Denham Springs, Walker, Watson areas</p>
            </div>
          </div>
        </div>
      </section>

      {/* Premium Equipment Brands Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Premium Equipment Brands We Buy in Baton Rouge
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              We purchase top-quality petrochemical and refinery equipment from leading manufacturers in Baton Rouge, Louisiana
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-lg border border-green-100">
              <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-settings-3-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Petrochemical Valves BR</h3>
              <p className="text-gray-600 mb-4">
                Fisher Control Valves Baton Rouge, Masoneilan Baton Rouge, Q-Check Baton Rouge, Valtek Baton Rouge
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-green-100 text-green-800 text-sm rounded">Fisher BR</span>
                <span className="px-2 py-1 bg-green-100 text-green-800 text-sm rounded">Masoneilan BR</span>
                <span className="px-2 py-1 bg-green-100 text-green-800 text-sm rounded">Q-Check BR</span>
              </div>
              <a href="/contact" className="text-green-600 hover:text-green-700 font-medium">Get BR Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-red-50 p-6 rounded-lg border border-orange-100">
              <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-dashboard-3-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Instrumentation BR</h3>
              <p className="text-gray-600 mb-4">
                Rosemount Transmitters Baton Rouge, Foxboro Baton Rouge, Fisher Instruments BR, Barton Baton Rouge
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-orange-100 text-orange-800 text-sm rounded">Rosemount BR</span>
                <span className="px-2 py-1 bg-orange-100 text-orange-800 text-sm rounded">Foxboro BR</span>
                <span className="px-2 py-1 bg-orange-100 text-orange-800 text-sm rounded">Fisher BR</span>
              </div>
              <a href="/contact" className="text-orange-600 hover:text-orange-700 font-medium">Get BR Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 p-6 rounded-lg border border-blue-100">
              <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-water-percent-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Flow Equipment BR</h3>
              <p className="text-gray-600 mb-4">
                Badger Meters Baton Rouge, Neptune Baton Rouge, Rockwell Baton Rouge, chemical flow systems
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-blue-100 text-blue-800 text-sm rounded">Badger BR</span>
                <span className="px-2 py-1 bg-blue-100 text-blue-800 text-sm rounded">Neptune BR</span>
                <span className="px-2 py-1 bg-blue-100 text-blue-800 text-sm rounded">Rockwell BR</span>
              </div>
              <a href="/contact" className="text-blue-600 hover:text-blue-700 font-medium">Get BR Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-indigo-50 p-6 rounded-lg border border-purple-100">
              <div className="w-12 h-12 bg-purple-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-cpu-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Actuators Baton Rouge</h3>
              <p className="text-gray-600 mb-4">
                Limitorque Baton Rouge, Bettis Actuators Baton Rouge, Fisher Actuators BR, Q-Check Actuators BR
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-purple-100 text-purple-800 text-sm rounded">Limitorque BR</span>
                <span className="px-2 py-1 bg-purple-100 text-purple-800 text-sm rounded">Bettis BR</span>
                <span className="px-2 py-1 bg-purple-100 text-purple-800 text-sm rounded">Fisher BR</span>
              </div>
              <a href="/contact" className="text-purple-600 hover:text-purple-700 font-medium">Get BR Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-cyan-50 p-6 rounded-lg border border-teal-100">
              <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-plug-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Fittings Baton Rouge</h3>
              <p className="text-gray-600 mb-4">
                Swagelok Baton Rouge, Parker Fittings Baton Rouge, Anderson Greenwood BR, Hoke Baton Rouge
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-teal-100 text-teal-800 text-sm rounded">Swagelok BR</span>
                <span className="px-2 py-1 bg-teal-100 text-teal-800 text-sm rounded">Parker BR</span>
                <span className="px-2 py-1 bg-teal-100 text-teal-800 text-sm rounded">Anderson BR</span>
              </div>
              <a href="/contact" className="text-teal-600 hover:text-teal-700 font-medium">Get BR Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-yellow-50 p-6 rounded-lg border border-amber-100">
              <div className="w-12 h-12 bg-amber-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-temp-hot-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Temperature Baton Rouge</h3>
              <p className="text-gray-600 mb-4">
                WIKA Gauges Baton Rouge, All Temp Sensors BR, OCI Baton Rouge, McDaniel Baton Rouge
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-amber-100 text-amber-800 text-sm rounded">WIKA BR</span>
                <span className="px-2 py-1 bg-amber-100 text-amber-800 text-sm rounded">All Temp BR</span>
                <span className="px-2 py-1 bg-amber-100 text-amber-800 text-sm rounded">OCI BR</span>
              </div>
              <a href="/contact" className="text-amber-600 hover:text-amber-700 font-medium">Get BR Quote →</a>
            </div>
          </div>

          <div className="mt-12 text-center">
            <div className="bg-gray-50 p-8 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Ready to Sell Your Equipment in Baton Rouge?</h3>
              <p className="text-lg text-gray-600 mb-6">
                Contact us today for a free quote on your surplus petrochemical and refinery equipment in Baton Rouge, Louisiana
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a href="tel:2148545638" className="bg-green-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-700 transition duration-300">
                  Call (214) 854-5638
                </a>
                <a href="/contact" className="bg-gray-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-700 transition duration-300">
                  Get Free Quote
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
            Frequently Asked Questions - **Baton Rouge**
          </h2>
          <div className="space-y-6">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-lg">
                <h3 className="text-lg font-bold text-blue-600 mb-3">**{faq.question}**</h3>
                <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-blue-600 to-blue-800">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-white mb-6">
            Ready to Sell Your **Industrial Equipment**?
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Get a professional evaluation from Louisiana's **trusted equipment buyers**
          </p>
          <div className="space-y-4 sm:space-y-0 sm:space-x-4 sm:flex sm:justify-center">
            <a href="tel:214-854-5638" className="block sm:inline-block bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-200">
              Call **214-854-5638**
            </a>
            <Link to="/contact" className="block sm:inline-block bg-white hover:bg-gray-100 text-blue-600 px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-200">
              Request Quote
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BatonRouge;
